import Tobii from "tobii";
import Blazy from "blazy";
// import getAverageColor from "./averageColor";

const html = document.querySelector("html");
const body = document.querySelector("body");
body.classList.add("js");

if (document.querySelectorAll(".lightbox").length > 0) {
	new Tobii();
}

new Blazy({
	selector: ".lazy",
	successClass: "loaded",
	success: function(element) {
		console.log(element.parentElement);
		// get the average color of header images
		if (element.parentElement.classList.contains("page-header-image")) {
			let avg = getAverageColor(element);
			console.log(avg);
			element.parentElement.style.backgroundColor = `rgb(${avg.r},${avg.g},${avg.b})`;
		}
	}
});

/** Toggle the mobile menu
* @returns {void}
*/
function toggleMobileMenu() {
	html.classList.toggle("menu-opened");
}

document.querySelector(".menu-toggler").addEventListener(
	"click",
	function(e) {
		e.preventDefault();
		toggleMobileMenu();
	},
	false
);

$(document).ready(function(){
	$(".homeSlider").slick({
	  dots: false,
	  infinite: true,
	  speed: 1500,
	  autoplay: true,
	  autoplaySpeed: 3000,
	  arrows: false,
	  mobileFirst:true,
	  // autoplay:true,
   	  // mobileFirst:true,//add this one
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  centerMode: false,
	  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
	});
});

// document.querySelector(".search-toggler").addEventListener(
// 	"click",
// 	function(e) {
// 		e.preventDefault();
//
// 		let mobileSearchEl = document.getElementById("mobileSearch");
//
// 		if (html.classList.contains("menu-opened")) {
// 			mobileSearchEl.focus();
// 		} else {
// 			html.classList.add("menu-opened");
// 			mobileSearchEl.focus();
// 		}
//
// 		return false;
// 	},
// 	false
// );

/** calculate the height of the mobile bar
 * @returns {void} nothin
 */
function calcMobileBarHeight() {
	console.log("calculate mobile bar height");
	let mobileBar = document.querySelector(".mobile-bar");
	let mobileMenu = document.querySelector(".mobile-menu");
	body.style.paddingTop = mobileBar.offsetHeight + "px";
	mobileMenu.style.paddingTop = mobileBar.offsetHeight + "px";
}

window.addEventListener("resize", calcMobileBarHeight);
window.addEventListener("load", calcMobileBarHeight);

var prevScrollpos = window.pageYOffset;

window.onscroll = function() {
  	var currentScrollPos = window.pageYOffset;
	var menu = document.getElementsByClassName('site-header')[0];
	var stickyTop = document.getElementsByClassName('sticky-top')[0];
	var logo = document.getElementsByClassName('peusen-logo')[0];
	var logoSmall = document.getElementsByClassName('small-logo')[0];
	var logoBig = document.getElementsByClassName('big-logo')[0];
	var svg = document.getElementsByClassName('layout')[0];
	var secondary = document.getElementsByClassName('menu-primary')[0];
	// const style = getComputedStyle(searchLang);

		if (( prevScrollpos ) == currentScrollPos || currentScrollPos < 1) {
			menu.classList.remove('scrolled');
			menu.classList.remove('bg-primary');
			logo.classList.remove('scrolled');
			logoSmall.classList.remove('scrolled');
			logoBig.classList.remove('d-none');
			svg.classList.remove('scrolled');
			secondary.style.marginTop = '3rem';
			secondary.style.transition = '.5 margin ease';

		} else {
			menu.classList.add('scrolled');
			menu.classList.add('bg-primary');
			logoSmall.classList.add('scrolled');
			logoBig.classList.add('d-none');
			logo.classList.add('scrolled');
			svg.classList.add('scrolled');
			secondary.style.marginTop = '4rem';
			secondary.style.transition = '.5 margin ease';
		}

	prevScrollpos = currentScrollPos;
}

//megamenu mobile
var mainItemsMobile = document.querySelectorAll('.mobile-arrow');
var megamenuItemsMobile  = document.querySelectorAll('.megamenu-item-mob');
var megamenuItemsMobileSecond  = document.querySelectorAll('.megamenu-item-mob-second');
var megamenuMobile  = document.getElementById('megamenu-mobile');
var megamenuMobileSecond  = document.getElementById('megamenu-mobile-second');
var close = document.getElementsByClassName('close-arrow')[0];
var closeSecond = document.getElementsByClassName('close-arrow')[1];

for (var i = 0; i < mainItemsMobile.length; i++) {
	mainItemsMobile[i].addEventListener("click", function( e ) {
				e.target.classList.add('active');
				megamenuMobile.classList.add('active');

		for (var i = 0; i < megamenuItemsMobile .length; i++) {
			if (megamenuItemsMobile[i].classList.contains(e.target.id)) {
				megamenuItemsMobile [i].classList.add('active');
			}
		}
	});

	close.addEventListener('click', function(e){
		e.target.classList.add('remove');
		megamenuMobile.classList.remove('active');

		for (var i = 0; i < megamenuItemsMobile .length; i++) {
			if (megamenuItemsMobile[i].classList.contains(e.target.id)) {
				megamenuItemsMobile [i].classList.remove('active');
			} else {
				megamenuItemsMobile [i].classList.remove('active');
			}
		}
	})
}

for (var i = 0; i < megamenuItemsMobile.length; i++) {
	megamenuItemsMobile[i].addEventListener("click", function( e ) {
				e.target.classList.add('active');
				megamenuMobileSecond.classList.add('active');

		for (var i = 0; i < megamenuItemsMobileSecond .length; i++) {
			if (megamenuItemsMobileSecond[i].classList.contains(e.target.id)) {
				megamenuItemsMobileSecond [i].classList.add('active');
			} else {
				megamenuItemsMobileSecond [i].classList.remove('active');
			}
		}
	});

	closeSecond.addEventListener('click', function(e){
		e.target.classList.add('remove');
		megamenuMobileSecond.classList.remove('active');
		megamenuMobile.classList.add('active');

		for (var i = 0; i < megamenuItemsMobileSecond .length; i++) {
			if (megamenuItemsMobileSecond[i].classList.contains(e.target.id)) {
				megamenuItemsMobileSecond [i].classList.remove('active');
			}
		}

	})
}

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
	this.classList.toggle("active");
	var content = this.nextElementSibling;
	if (content && content.style.display === "block") {
	  content.style.display = "none";
	} else {
	  content.style.display = "block";
	}
  });
}
